"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.models = exports.dismissNotification = exports.dismissNotificationForAll = exports.updateNotification = exports.getNotification = exports.getAllNotifications = exports.createNotification = exports.putCustomData = exports.getCustomData = exports.getAllFlagsByLocation = exports.getAllDeliveryCalendarsByLocation = exports.getAllCountryCalendarsByLocation = exports.getAllTransitCalendarsByLocation = exports.getAllPickupCalendarsForLocation = exports.removeNetworkUser = exports.addNetworkUser = exports.unlinkResourceFromNetworkGroup = exports.linkResourceToNetworkGroup = exports.updateLogisticsNetwork = exports.createLogisticsNetwork = exports.getLogisticsNetwork = exports.getLogisticsNetworks = exports.removeUser = exports.addUser = exports.unlinkResourceFromLocationGroup = exports.linkResourceToLocationGroup = exports.updateLocation = exports.createLocation = exports.getLocationByFlId = exports.getLocation = exports.getLocations = void 0;
const axios_1 = require("axios");
const moment = require("moment");
const models = require("../models/locations");
exports.models = models;
const shared_1 = require("./shared");
async function getLocations(authorization, correlationId, params) {
    const getAll = async (paginationUrl) => {
        const url = paginationUrl || `${shared_1.getBaseUrl()}/v0/locations`;
        const request = {
            headers: shared_1.getHeaders(authorization, correlationId),
        };
        if (params &&
            (params.search || params.fulfillmentLocationId || params.excludes)) {
            request.params = params;
        }
        const apiResponse = (await axios_1.default.get(url, request)).data;
        const locations = apiResponse.items;
        if (apiResponse._links.next) {
            locations.push(...(await getAll(apiResponse._links.next.href)));
        }
        return locations;
    };
    return getAll();
}
exports.getLocations = getLocations;
async function getLocation(authorization, correlationId, locationId) {
    try {
        const response = (await axios_1.default.get(`${shared_1.getBaseUrl()}/v0/locations/${locationId}`, {
            headers: shared_1.getHeaders(authorization, correlationId),
        })).data;
        return response;
    }
    catch (error) {
        if (error.response && error.response.status === 404) {
            return undefined;
        }
        throw error;
    }
}
exports.getLocation = getLocation;
async function getLocationByFlId(authorization, correlationId, fulfillmentLocationId) {
    try {
        const response = (await axios_1.default.get(`${shared_1.getBaseUrl()}/v0/fulfillmentLocations/${fulfillmentLocationId}/logisticsLocation`, {
            headers: shared_1.getHeaders(authorization, correlationId),
        })).data;
        return response;
    }
    catch (error) {
        if (error.response && error.response.status === 404) {
            return undefined;
        }
        throw error;
    }
}
exports.getLocationByFlId = getLocationByFlId;
async function createLocation(authorization, correlationId, location) {
    const response = await axios_1.default.post(`${shared_1.getBaseUrl()}/v0/locations`, location, {
        headers: shared_1.getHeaders(authorization, correlationId),
    });
    return response.headers.location.split('/').pop(); // locationId
}
exports.createLocation = createLocation;
async function updateLocation(authorization, correlationId, locationId, etag, patch) {
    await axios_1.default.patch(`${shared_1.getBaseUrl()}/v0/locations/${locationId}`, patch, {
        headers: Object.assign(Object.assign({}, shared_1.getHeaders(authorization, correlationId)), { 'if-match': etag }),
    });
}
exports.updateLocation = updateLocation;
async function linkResourceToLocationGroup(authorization, correlationId, locationId, resourceIdentifier, resourceType) {
    await axios_1.default.post(`${shared_1.getBaseUrl()}/v0/locations/${locationId}/linkedResources`, { resourceType, resourceIdentifier }, {
        headers: shared_1.getHeaders(authorization, correlationId),
    });
}
exports.linkResourceToLocationGroup = linkResourceToLocationGroup;
async function unlinkResourceFromLocationGroup(authorization, correlationId, locationId, resourceIdentifier, resourceType) {
    await axios_1.default.delete(`${shared_1.getBaseUrl()}/v0/locations/${locationId}/linkedResources`, {
        headers: shared_1.getHeaders(authorization, correlationId),
        params: { resourceType, resourceIdentifier },
    });
}
exports.unlinkResourceFromLocationGroup = unlinkResourceFromLocationGroup;
async function manageUser(authorization, correlationId, locationId, email, role) {
    const response = await axios_1.default.post(`${shared_1.getBaseUrl()}/v0/locations/${locationId}/users`, { email, role }, {
        headers: shared_1.getHeaders(authorization, correlationId),
    });
    return response.headers.etag;
}
async function addUser(authorization, correlationId, locationId, email, role) {
    return manageUser(authorization, correlationId, locationId, email, role);
}
exports.addUser = addUser;
async function removeUser(authorization, correlationId, locationId, email) {
    return manageUser(authorization, correlationId, locationId, email);
}
exports.removeUser = removeUser;
async function getLogisticsNetworks(authorization, correlationId) {
    const getAll = async (paginationUrl) => {
        const url = paginationUrl || `${shared_1.getBaseUrl()}/v0/networks`;
        const request = {
            headers: shared_1.getHeaders(authorization, correlationId),
        };
        const apiResponse = (await axios_1.default.get(url, request)).data;
        const logisticsNetworks = apiResponse.items;
        if (apiResponse._links.next) {
            logisticsNetworks.push(...(await getAll(apiResponse._links.next.href)));
        }
        return logisticsNetworks;
    };
    return getAll();
}
exports.getLogisticsNetworks = getLogisticsNetworks;
async function getLogisticsNetwork(authorization, correlationId, logisticsNetworkId) {
    try {
        const response = await axios_1.default.get(`${shared_1.getBaseUrl()}/v0/networks/${logisticsNetworkId}`, {
            headers: shared_1.getHeaders(authorization, correlationId),
        });
        return response.data;
    }
    catch (error) {
        if (error.response && error.response.status === 404) {
            return undefined;
        }
        throw error;
    }
}
exports.getLogisticsNetwork = getLogisticsNetwork;
async function createLogisticsNetwork(authorization, correlationId, logisticsNetwork) {
    const response = await axios_1.default.post(`${shared_1.getBaseUrl()}/v0/networks`, logisticsNetwork, {
        headers: shared_1.getHeaders(authorization, correlationId),
    });
    return response.headers.location.split('/').pop(); // logisticsNetworkId
}
exports.createLogisticsNetwork = createLogisticsNetwork;
async function updateLogisticsNetwork(authorization, correlationId, logisticsNetworkId, etag, patch) {
    return axios_1.default.patch(`${shared_1.getBaseUrl()}/v0/networks/${logisticsNetworkId}`, patch, {
        headers: Object.assign(Object.assign({}, shared_1.getHeaders(authorization, correlationId)), { 'if-match': etag }),
    });
}
exports.updateLogisticsNetwork = updateLogisticsNetwork;
async function linkResourceToNetworkGroup(authorization, correlationId, networkId, resourceIdentifier, resourceType) {
    await axios_1.default.post(`${shared_1.getBaseUrl()}/v0/networks/${networkId}/linkedResources`, { resourceType, resourceIdentifier }, {
        headers: shared_1.getHeaders(authorization, correlationId),
    });
}
exports.linkResourceToNetworkGroup = linkResourceToNetworkGroup;
async function unlinkResourceFromNetworkGroup(authorization, correlationId, networkId, resourceIdentifier, resourceType) {
    await axios_1.default.delete(`${shared_1.getBaseUrl()}/v0/networks/${networkId}/linkedResources`, {
        headers: shared_1.getHeaders(authorization, correlationId),
        params: { resourceType, resourceIdentifier },
    });
}
exports.unlinkResourceFromNetworkGroup = unlinkResourceFromNetworkGroup;
async function manageNetworkUser(authorization, correlationId, networkId, email, role) {
    const response = await axios_1.default.post(`${shared_1.getBaseUrl()}/v0/networks/${networkId}/users`, { email, role }, {
        headers: shared_1.getHeaders(authorization, correlationId),
    });
    return response.headers.etag;
}
async function addNetworkUser(authorization, correlationId, networkId, email, role) {
    return manageNetworkUser(authorization, correlationId, networkId, email, role);
}
exports.addNetworkUser = addNetworkUser;
async function removeNetworkUser(authorization, correlationId, networkId, email) {
    return manageNetworkUser(authorization, correlationId, networkId, email);
}
exports.removeNetworkUser = removeNetworkUser;
async function getAllPickupCalendarsForLocation(authorization, correlationId, locationId, options) {
    const dateTimeFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
    const getParams = (opts) => {
        if (!opts) {
            return {};
        }
        return Object.entries(opts).reduce((acc, curr) => {
            const [key, value] = curr;
            if (['startDateTime', 'endDateTime'].includes(key)) {
                acc[key] = moment(value).format(dateTimeFormat);
                return acc;
            }
            acc[key] = value;
            return acc;
        }, {});
    };
    try {
        const response = await axios_1.default.get(`${shared_1.getBaseUrl()}/v0/locations/${locationId}/pickupCalendars`, {
            params: getParams(options),
            headers: shared_1.getHeaders(authorization, correlationId),
        });
        return response.data;
    }
    catch (error) {
        if (error.response && error.response.status === 404) {
            return undefined;
        }
        throw error;
    }
}
exports.getAllPickupCalendarsForLocation = getAllPickupCalendarsForLocation;
function formatDatesInOptions(opts) {
    const dateFormat = 'YYYY-MM-DD';
    if (!opts) {
        return {};
    }
    if (opts.startDate) {
        opts.startDate = moment(opts.startDate).format(dateFormat);
    }
    if (opts.endDate) {
        opts.endDate = moment(opts.endDate).format(dateFormat);
    }
    return opts;
}
async function getAllTransitCalendarsByLocation(accessToken, correlationId, locationId, options) {
    const result = (await axios_1.default.get(`${shared_1.getBaseUrl()}/v0/locations/${locationId}/transitCalendars`, {
        headers: shared_1.getHeaders(accessToken, correlationId),
        params: formatDatesInOptions(options),
    })).data;
    return result;
}
exports.getAllTransitCalendarsByLocation = getAllTransitCalendarsByLocation;
async function getAllCountryCalendarsByLocation(accessToken, correlationId, locationId, options) {
    const result = (await axios_1.default.get(`${shared_1.getBaseUrl()}/v0/locations/${locationId}/countryCalendars`, {
        headers: shared_1.getHeaders(accessToken, correlationId),
        params: formatDatesInOptions(options),
    })).data;
    return result;
}
exports.getAllCountryCalendarsByLocation = getAllCountryCalendarsByLocation;
async function getAllDeliveryCalendarsByLocation(accessToken, correlationId, locationId, options) {
    const result = (await axios_1.default.get(`${shared_1.getBaseUrl()}/v0/locations/${locationId}/deliveryCalendars  `, {
        headers: shared_1.getHeaders(accessToken, correlationId),
        params: formatDatesInOptions(options),
    })).data;
    return result;
}
exports.getAllDeliveryCalendarsByLocation = getAllDeliveryCalendarsByLocation;
async function getAllFlagsByLocation(accessToken, correlationId, locationId) {
    const result = (await axios_1.default.get(`${shared_1.getBaseUrl()}/v0/locations/${locationId}/flags`, {
        headers: shared_1.getHeaders(accessToken, correlationId),
    })).data;
    return result;
}
exports.getAllFlagsByLocation = getAllFlagsByLocation;
async function getCustomData(accessToken, correlationId, locationId, customDataId) {
    try {
        const result = await axios_1.default.get(`${shared_1.getBaseUrl()}/v0/locations/${locationId}/customData/${customDataId}`, {
            headers: shared_1.getHeaders(accessToken, correlationId),
        });
        return { data: result.data, etag: result.headers.etag };
    }
    catch (error) {
        if (error.response && error.response.status === 404) {
            return undefined;
        }
        throw error;
    }
}
exports.getCustomData = getCustomData;
async function putCustomData(accessToken, correlationId, locationId, customDataId, customData, etag) {
    const response = await axios_1.default.put(`${shared_1.getBaseUrl()}/v0/locations/${locationId}/customData/${customDataId}`, customData, {
        headers: Object.assign(Object.assign({}, shared_1.getHeaders(accessToken, correlationId)), (etag && { 'if-match': etag })),
    });
    return response.headers.etag;
}
exports.putCustomData = putCustomData;
async function createNotification(accessToken, correlationId, notification) {
    const response = await axios_1.default.post(`${shared_1.getBaseUrl()}/v0/locations/${notification.locationId}/notifications`, notification, {
        headers: shared_1.getHeaders(accessToken, correlationId),
    });
    return response.headers.location.split('/').pop(); // notificationId
}
exports.createNotification = createNotification;
async function getAllNotifications(accessToken, correlationId, locationId) {
    const response = (await axios_1.default.get(`${shared_1.getBaseUrl()}/v0/locations/${locationId}/notifications`, {
        headers: shared_1.getHeaders(accessToken, correlationId),
    })).data;
    return response;
}
exports.getAllNotifications = getAllNotifications;
async function getNotification(accessToken, correlationId, locationId, notificationId) {
    try {
        const response = (await axios_1.default.get(`${shared_1.getBaseUrl()}/v0/locations/${locationId}/notifications/${notificationId}`, {
            headers: shared_1.getHeaders(accessToken, correlationId),
        })).data;
        return response;
    }
    catch (error) {
        if (error.response && error.response.status === 404) {
            return undefined;
        }
        throw error;
    }
}
exports.getNotification = getNotification;
async function updateNotification(authorization, correlationId, locationId, notificationId, patch) {
    await axios_1.default.patch(`${shared_1.getBaseUrl()}/v0/locations/${locationId}/notifications/${notificationId}`, patch, {
        headers: shared_1.getHeaders(authorization, correlationId),
    });
}
exports.updateNotification = updateNotification;
async function dismissNotificationForAll(authorization, correlationId, locationId, notificationId) {
    const operation = [
        {
            path: models.locationStatePath,
            op: 'replace',
            value: 'dismissed-for-all',
        },
    ];
    await updateNotification(authorization, correlationId, locationId, notificationId, operation);
}
exports.dismissNotificationForAll = dismissNotificationForAll;
async function dismissNotification(authorization, correlationId, locationId, notificationId) {
    const operation = [
        {
            path: models.userStatePath,
            op: 'replace',
            value: 'dismissed',
        },
    ];
    await updateNotification(authorization, correlationId, locationId, notificationId, operation);
}
exports.dismissNotification = dismissNotification;
//# sourceMappingURL=locations.v0.js.map